import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64fd5ed3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tweet" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Tweet", -1))

import FormComponent from '@/components/FormComponent.vue';
import ListComponent from '@/components/ListComponent.vue';
import { ref,provide } from 'vue';

type Tweet ={
  description:string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const tweets = ref<Tweet[]>([]);

const addTweet = (description:string)=>{
  const newTweet:Tweet = {
    description
  }
  tweets.value.push(newTweet);
}

const deleteTweet = (index: number) => {
  tweets.value.splice(index, 1);
}

provide('tweets', tweets);
provide('addTweet', addTweet);
provide('deleteTweet', deleteTweet);
  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(FormComponent),
    _createVNode(ListComponent)
  ]))
}
}

})